import React, { useState, useEffect } from 'react';
import InputList from './InputList';

const IL_UserQuestions = ({
  questionnaireCriteria,
  onCriteriaChange,
  label = "User Questions",
  placeholder = "Enter a question...",
  emptyMessage = "No user questions added yet"
}) => {

  // Extract user questions from questionnaire criteria
  const getInitialQuestions = () => {
    if (questionnaireCriteria?.userQuestions?.items) {
      return questionnaireCriteria.userQuestions.items.map(item => ({
        title: item.question,
        subtitle: item.rationale || ''
      }));
    }
    return [];
  };

  // State for user questions
  const [questions, setQuestions] = useState(getInitialQuestions());

  // Update questions when questionnaireCriteria changes
  useEffect(() => {
    setQuestions(getInitialQuestions());
  }, [questionnaireCriteria]);

  // Update user questions criteria JSON
  const updateUserQuestionsCriteria = (newQuestions) => {
    if (!questionnaireCriteria) return;

    // Create updated criteria with new user questions
    const updatedCriteria = {
      ...questionnaireCriteria,
      userQuestions: {
        ...questionnaireCriteria.userQuestions,
        items: newQuestions.map(questionItem => {
          // Check if this question already exists in our current criteria
          const existingQuestion = questionnaireCriteria.userQuestions?.items?.find(
            item => item.question === questionItem.title
          );
          
          if (existingQuestion) {
            // Keep existing question with all its properties
            return existingQuestion;
          } else {
            // Create new question entry with userQuestions specific structure
            return {
              question: questionItem.title,
              rationale: questionItem.subtitle || "",
              context: []
            };
          }
        })
      }
    };

    // Call parent callback with only the updated criteria
    onCriteriaChange(updatedCriteria);
  };

  // Handle questions change
  const handleQuestionsChange = (newQuestions) => {
    setQuestions(newQuestions);
    updateUserQuestionsCriteria(newQuestions);
  };

  return (
    <InputList
      items={questions}
      onItemsChange={handleQuestionsChange}
      label={label}
      placeholder={placeholder}
      emptyMessage={emptyMessage}
    />
  );
};

export default IL_UserQuestions;
